import CircularProgress from '@mui/material/CircularProgress';
import { PrimaryButton } from './styles';

interface ButtonProps {
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary';
  onClick?: () => void;
  text: string;
  disabled?: boolean;
  loading?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const Button = ({
  variant = 'contained',
  color = 'primary',
  onClick,
  text,
  disabled = false,
  loading = false,
  size = 'large',
}: ButtonProps) => {
  return (
    <PrimaryButton
      variant={variant}
      size={size}
      disabled={disabled || loading}
      color={color}
      onClick={onClick}
      fullWidth
      aria-busy={loading}
    >
      {loading ? <CircularProgress size={24} color="inherit" aria-label="Loading" /> : text}
    </PrimaryButton>
  );
};

export default Button;
